import axios from "axios";
import { environment } from "@environments/environment";

const apiInstance = axios.create({
  baseURL: environment?.gateWayUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function verifyPhoneNumber(phoneData: {
  dialCode: string;
  number: string;
}) {
  try {
    const response = await apiInstance.post(
      `/api/v1/user/agents/verify`,
      {
        isd_code: phoneData.dialCode,
        phone: phoneData.number.toString(),
      },
      {
        headers: {
          "tenant-id": "1",
          "product-id": "1000",
          platform: "web",
        },
      }
    );

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Failed to verify phone number");
    }
  } catch (error) {
    console.error("Error verifying phone number:", error);
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export async function generateOtp(obj: any) {
  const enableCaptcha = environment?.enableCaptachaIntegration;
  try {
    const oldurl = `${environment.commService}/api/generate-otp`;
    const urlV3 = `${environment.commService}/api/v3/generate-otp`;
    const body = {
      isd_code: obj?.dialCode.toString(),
      phone: obj?.number?.toString(),
      tenant_id: 1,
      product_id: 1000,
      ...(obj.firstName && { firstName: obj.firstName }),
      ...(obj.lastName && { lastName: obj.lastName }),
      ...(obj.gradeId && { gradeId: obj.gradeId }),
      ...(obj.admissionNumber && { admissionNumber: obj.admissionNumber }),
    };

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    if (obj?.register) {
      headers["X-Page"] = "REGISTER_GENERATE";
      headers["X-Platform"] = "web";
      headers["X-Product"] = "1";
    }
    if (enableCaptcha && obj?.captcha_token) {
      body["captcha_token"] = obj?.captcha_token;
    }
    const url = enableCaptcha ? urlV3 : oldurl;
    const response = await axios.post(url, body, { headers });

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Failed to generate OTP");
    }
  } catch (error) {
    console.error("Error generating OTP:", error);
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export async function validateOtp(inp: {
  countryCode: string;
  phone: string;
  otp: string;
  register?: boolean;
  page?: string;
}) {
  try {
    const { countryCode, phone, otp, register, page = "WEB_IL_SITE" } = inp;

    const body = {
      isd_code: countryCode,
      phone: phone?.toString(),
      otp: otp?.toString(),
      product_id: 1000,
      tenant_id: 1,
    };

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    if (register) {
      headers["X-Page"] = `REGISTER_VALIDATE_${page}`;
      headers["X-Platform"] = "web";
      headers["X-Product"] = "1";
    } else {
      headers["product-id"] = "1000";
      headers["tenant-id"] = "1";
      headers["platform"] = "web";
    }

    const response = await apiInstance.post(
      `/api/v1/user/agents/login-with-otp`,
      body,
      { headers }
    );

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Failed to validate OTP");
    }
  } catch (error: any) {
    console.error("Error validating OTP:", error);
    // If it's an axios error, surface server's message
    if (error?.response?.data?.detail) {
      throw new Error(error?.response.data.detail);
    }

    // Otherwise, fallback to generic
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}
